import { ThemeSTDKeys, ThemeSTDConfigs } from '@naruto/bgdcms/src/base/theme/normal';
import { CreateBreakUnits, CreateBreakPoint } from '@naruto/bgdcms/src/base/theme/normal/default/BreakPoint';

/* 主題設定 : 可用列表 */
const ThemeLocalKeys = { ...ThemeSTDKeys };

/* 主題設定 : 可用設定檔 */
const ThemeLocalConfig = { ...ThemeSTDConfigs };

export { ThemeLocalKeys, ThemeLocalConfig, CreateBreakUnits, CreateBreakPoint };
